import { render, staticRenderFns } from "./ECEntityAddressList.vue?vue&type=template&id=c0da2ea4"
import script from "./ECEntityAddressList.vue?vue&type=script&lang=js"
export * from "./ECEntityAddressList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports